import { Icon24CutLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const TrimIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path d="M11.5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z" fill="currentColor" />
      <circle cx="18" cy="12" r="0.5" fill="currentColor" />
      <path d="M15 12h1" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      <path d="M8 12h1" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      <circle cx="6" cy="12" r="0.5" fill="currentColor" />
    </svg>
  );
};

export const TrimIcon = fplIcon(TrimIconLocal, Icon24CutLarge);
